import { createFileRoute } from '@tanstack/react-router'

import {
    INVENTORY_FILTERS,
    InventoryTab,
} from '@/components/reports/inventory-tab'
import { ReportPage } from '@/components/reports/report-page'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/reports/inventory',
)({
    validateSearch: INVENTORY_FILTERS.validateSearch,
    component: InventoryReportPage,
})

function InventoryReportPage() {
    const search = Route.useSearch()
    const navigate = Route.useNavigate()
    return (
        <ReportPage title={m.report_page_title_inventory()}>
            <InventoryTab
                search={search}
                onSearchChange={(next, opts) =>
                    void navigate({
                        search: next,
                        replace: opts?.replace ?? false,
                    })
                }
            />
        </ReportPage>
    )
}
